export var PRODUCT_WIDGET_DSN = 'https://04ac210d4a934172b7aead660647e5a0@sentry.io/1411933';
export var translationPath = function (baseUrl, locale) {
    if (locale === void 0) { locale = 'en'; }
    return baseUrl + "assets/locale/productWidget/productWidget_" + locale + ".json";
};
export var widgetId = '13ec3e79-e668-cc0c-2d48-e99d53a213dd';
//# sourceMappingURL=constants.js.map